module.exports = __webpack_public_path__ + "static/media/twitterXLogo.7f0d3078.svg";